import { Action, getModule, Module } from 'vuex-module-decorators';

import store from '@/store';
import EntityBaseModule from '@/store/entity';
import ResponseHandlerModule from '@/store/modules/responseHandler';

import { Administrators } from '@/models/administrators';
import { AdministratorCard, AdministratorModel } from '@/types/models/administrators';

import { addNewEntity, getById, removeEntity, updateEntity } from '@/api/crud';

import EntityModel from './entityModel';
import { activateAdministrator, deactivateAdministrator } from '@/api/administrators';

export const MODULE_NAME = Administrators.moduleEntityName;

@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class AdministratorEntityModule extends EntityBaseModule {
    model: AdministratorModel;

    constructor(module: AdministratorEntityModule) {
        super(module);

        const entityModel = new EntityModel();
        this.model = entityModel.model;
    }

    @Action({ rawError: true })
    async getById(id: string): Promise<AdministratorCard> {
        try {
            const result = await getById(Administrators.moduleName, id);

            return result.administrator;
        } catch (clientError) {
            const error = clientError.response.data;

            throw new Error(error.message);
        }
    }

    @Action({ rawError: true })
    async createNew(data: Record<string, any>) {
        const { result } = await addNewEntity(Administrators.moduleName, data);

        return result.id;
    }

    @Action({ rawError: true })
    async update(params: { id: string; data: Record<string, any> }) {
        return updateEntity(Administrators.moduleName, params.id, params.data);
    }

    @Action({ rawError: true })
    async remove(id: string) {
        return removeEntity(Administrators.moduleName, id)
    }

    @Action({ rawError: true })
    async activate(id: string) {
        try {
            await activateAdministrator(id);
        } catch (error) {
            if (error.response?.data) {
                ResponseHandlerModule.showNotify({ message: error.response.data, type: 'fail' });
                return;
            }
            ResponseHandlerModule.showNotify({ message: error, type: 'fail' });
        }
    }

    @Action({ rawError: true })
    async deactivate(id: string) {
        try {
            await deactivateAdministrator(id);
        } catch (error) {
            if (error.response?.data) {
                ResponseHandlerModule.showNotify({ message: error.response.data, type: 'fail' });
                return;
            }
            ResponseHandlerModule.showNotify({ message: error, type: 'fail' });
        }
    }

    @Action({ rawError: true })
    async getIsActive(id: string) {
        try {
            const result = await this.getById(id);
            return result.is_active;
        } catch (error) {
            if (error.response?.data) {
                ResponseHandlerModule.showNotify({ message: error.response.data, type: 'fail' });
                return;
            }
            ResponseHandlerModule.showNotify({ message: error, type: 'fail' });
        }
    }
}

export default getModule(AdministratorEntityModule);
